export default __webpack_public_path__ + "static/media/logo3.3d2fc72a.png";